"use strict";

import { Model } from "../model";
import { Objects } from "Constants/objects";
export var FormGroupsModel = Model.extend({
  initialize: function initialize() {
    this.object = Objects.SysFormGroups;
  }
});